<template>
  <div class="is-relative">
    <div class="autocomplete-results" v-if="result">
      <ul class="autocomplete-results__result-list">
        <li
          class="autocomplete-results__result-list__item"
          v-if="result && result.length == 0"
        >
          {{ $t("nothingFound") }}
        </li>

        <li
          class="autocomplete-results__result-list__item"
          v-for="item in result"
          :key="item"
          v-on:click="selectResult(item)"
        >
          <span class="autocomplete-results__result-list__icon">
            <i :class="getFeatureCodeIcon(item.featureCode)"></i>
          </span>
          <span class="autocomplete-results__result-list__name">
            {{ getText(item) }}
          </span>
        </li>
      </ul>
    </div>

    <div class="searchbar__icon">
      <i class="fas fa-location-dot"></i>
    </div>
    <input
      type="text"
      v-bind:name="name"
      v-model="searchInput"
      id="searchInput"
      v-on:keyup="getResults"
      class="searchbar__input"
      :placeholder="$t('location')"
      :class="{ 'searchbar__input--loading': isLoading }"
      autocomplete="off"
    />
  </div>
</template>

<script>
import commonHelper, { getFeatureCodeIcon } from "@/helpers/common.helper";

export default {
  name: "LandingLocationSelector",
  props: {
    name: String,
    input: String
  },
  emits: ["selectLocation"],
  data() {
    return {
      callId: null,
      isLoading: false,
      result: null,
      searchInput: "",
      lastSearched: null
    };
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    getFeatureCodeIcon,
    async getResults() {
      if (this.searchInput && this.searchInput.length >= 1) {
        if (this.searchInput == this.lastSearched) {
          return;
        }
        const searchInput = this.searchInput;
        if (this.callId) {
          clearTimeout(this.callId);
        }
        this.callId = setTimeout(async () => {
          this.isLoading = true;
          const data = await commonHelper.getLocationsFromSearch(searchInput);
          this.lastSearched = searchInput;
          this.result = data.slice(0, 10);
          this.isLoading = false;
        }, 750);
      } else {
        this.result = [];
      }
    },
    selectResult(locationItem) {
      this.searchInput = locationItem.name;
      this.result = null;
      this.$emit("selectLocation", locationItem);
    },
    getText(item) {
      let string = "";
      if (item.name) {
        string += `${item.name}`;
      }

      if (item.admin1) {
        if (item.name) {
          string += ` -`;
        }
        string += ` ${item.admin1}`;
      }
      if (item.country) {
        string += `, ${item.country}`;
      }

      return string;
    },
    handleClickOutside(event) {
      if (this.$el && !this.$el.contains(event.target)) {
        this.result = null;
      }
    }
  },
  watch: {
    input: {
      immediate: true,
      handler(val) {
        if (val) this.searchInput = val;
      }
    }
  }
};
</script>
